<template>
    <div class="display_wrapper">

        <!-- <input type="file" id="file" accept="image/*"> -->

        <v-toolbar :height="56" flat>

            <v-toolbar-title>Group</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn outlined small @click="fn_edit" color="primary" v-if="displayData && !displayData.isSystem">
                <v-icon left>edit</v-icon> Edit
            </v-btn>

            <v-btn class="ml-4" small outlined @click="fn_openDialogConfirmation" color="red" v-if="displayData && !displayData.isSystem">
                <v-icon left>delete</v-icon> Delete
            </v-btn>

            <!-- <v-btn icon @click="fn_getBottomMenu">
              <v-icon>more_vert</v-icon>
            </v-btn> -->
        </v-toolbar>

        <v-divider></v-divider>

        <div class="data-container grey-back" v-if="displayData">
            <div class="title pa-4 white-back">{{displayData.name}}</div>

            <v-list class="mt-2 nopadding" two-line>
                <v-subheader light>Details</v-subheader>
                <v-divider></v-divider>
                <div>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>Is Primary Group</v-list-item-title>
                            <v-list-item-subtitle>{{displayData.isPrimaryAccountGroup ? 'Yes' : 'No'}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                </div>
                <div v-if="!displayData.isPrimaryAccountGroup">
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>Parent Group</v-list-item-title>
                            <v-list-item-subtitle>{{displayData.parentAccountGroup.name}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if="displayData.isPrimaryAccountGroup"></v-divider>
                </div>
                <div v-if="displayData.isPrimaryAccountGroup">
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>Nature</v-list-item-title>
                            <v-list-item-subtitle>{{getNature(displayData.nature) ? getNature(displayData.nature) : '-'}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <!-- <v-divider></v-divider> -->
                </div>

            </v-list>
        </div>

        <v-row class="fill-height" align-content="center" justify="center" style="position:absolute;top:0;bottom:0;width: calc(100% - 280px);" v-if="loading">
          <v-col cols="6">
            <v-progress-linear rounded indeterminate :height="6" color="primary"></v-progress-linear>
          </v-col>
        </v-row>

        <dialog-confirmation ref="ref_dialogDeleteConfirmation" header="Delete Master?" :actionMethod="fn_deleteMaster" params="delete" :displayView="true"></dialog-confirmation>
    </div>
</template>

<script>
// const menuItem = require('../../../../config.js').configs.menuItem;
import {masterMixin} from '../../master_mixin.js'
import dialogConfirmation from '../../../dialogs/dialog_confirmation'

// import Tesseract from "tesseract.js";

import { createWorker } from "tesseract.js";

let worker;

export async function initOCR() {
  if (!worker) {
    worker = await createWorker("eng", 1, {
      logger: m => console.log(m)
    });

    await worker.setParameters({
      tessedit_pageseg_mode: 6,         // Best for invoice blocks
      tessedit_ocr_engine_mode: 1,     // LSTM only (more accurate)
      preserve_interword_spaces: 1,
      user_defined_dpi: 300,
    });
  }
}

export async function runOCR(file) {
  if (!worker) await initOCR();

  const { data } = await worker.recognize(file);

  return data;
}

    export default{
        mixins: [masterMixin],
        data(){
            return{
                displayData:null,
                loading:false
            }
        },
        components:{
            'dialog-confirmation': dialogConfirmation
        },
        methods:{
            getNature: function(natureIndex){
                var nature;
                natureIndex == 101 ? nature = 'Assets' : natureIndex == 102 ? nature = 'Expenses' : natureIndex == 103 ? nature = 'Income' : natureIndex == 104 ? nature = 'Liabilities' : '';
                return nature;
            },

            fn_get: function(itemId){
                this.loading = true;
                this.displayData = false;

                var self = this;
                this.getData('AccountGroups', itemId, 
                    {
                        onSuccess: function(response){
                          console.log(response);
                          self.displayData = JSON.parse(response);
                          self.loading = false;
                        }, 
                        onError: function(error){
                          console.log(error);
                          self.loading = false;
                        }
                    }
                );
            },

            // fn_showWebView: function () {
            //     var viewObject = {};
            //     viewObject.ToolbarTitle = "Account Groups";
            //     viewObject.TopMenu = [menuItem.edit];
            //     viewObject.isBottomMenu = true;

            //     var tagId = null;
            //     this.$route.params && this.$route.params.tagId ? tagId = this.$route.params.tagId : '';
            //     var self = this;

            //     this.showWebView(tagId, viewObject, 
            //         {
            //             onSuccess: function(response){
            //               console.log(response);
            //             }, 
            //             onError: function(error){
            //               console.log(error);
            //             }, 
            //             // onChange: null, 
            //             onMenuItemClick: function (tagId, menuId, menuAction) {
            //                 self.fn_menuItemClick(tagId, menuId, menuAction)
            //             }
            //         }
            //     );
            // },

            // fn_getBottomMenu: function (tagId) {
            //     var bottomMenu = {"BottomMenu": [menuItem.copy]};
            //     !this.displayData.isSystem ? bottomMenu.BottomMenu.push(menuItem.delete) : '';

            //     this.setBottomMenu(tagId, bottomMenu, 
            //         {
            //             onSuccess: function (response) {
            //                 console.log(response);
            //             },
            //             onError: function (error) {
            //                 console.log(error);
            //             }
            //         }
            //     )
            // },

            // fn_menuItemClick: function(tagId, menuId, menuAction){
            //     // tagId id form future use
            //     // menuId id form future use
            //     if(menuAction=='edit' && this.displayData && this.displayData.accountGroupId){
            //         this.fn_edit();
            //     }
            //     else if(menuAction=='copy'){
            //         this.$router.push({path:'/masters/accounts/groups/new', query:{tagId:this.guidWeb(), itemId:this.displayData.accountGroupId, copy:true}});
            //     }
            //     else if(menuAction=='delete'){
            //         this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = true;
            //     }
            // },

            fn_openDialogConfirmation: function(){
                this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = true;
            },

            fn_deleteMaster: function(){
                let self = this;
                this.$refs['ref_dialogDeleteConfirmation'].dialog_confimation = false;
                this.fn_deleteMasterItem('accountGroup', this.displayData.accountGroupId, function(response){
                    if(response){
                        // alert('Item deleted');
                        self.$eventHub.$emit('snackbarAlert', {msg:'Item deleted'});
                        self.$eventHub.$emit('UpdateAccountGroupList', {});
                        self.$router.go(-1);
                    }
                    else{
                        // alert("Item cannot be deleted as already in use");
                        self.$eventHub.$emit('snackbarAlert', {msg:'Item cannot be deleted as already in use.'});
                    }
                })
            },

            fn_edit: function () {
                this.$router.push('/'+this.$route.params.businessId+'/'+this.$route.params.listId+'/account_group/items/'+this.displayData.accountGroupId+'/edit');
            },

            parseInvoiceOCR(rawText) {

                /* -----------------------------
                    1. BASIC WORD CORRECTIONS
                ----------------------------- */

                const WORD_FIXES = {
                    inveice: "invoice",
                    dato: "date",
                    deli: "delhi",
                    stn: "gstin",
                    bil: "Bill",
                    shipTo: "Ship To",
                    tem: "Item",
                    pes: "pcs",
                    fit: "fifty",
                    al: "all"
                };

                function fixWords(text) {
                    return text.replace(/\b\w+\b/g, word => {
                    const lower = word.toLowerCase();
                    return WORD_FIXES[lower] || word;
                    });
                }

                let text = fixWords(rawText);


                /* -----------------------------
                    2. EXTRACT HEADER DATA
                ----------------------------- */

                const invoiceNo = text.match(/invoice\s*no[:\s]*([A-Z0-9]+)/i)?.[1] || "";

                const invoiceDate = text.match(/date\s*of.*?:?\s*([0-9]{1,2}[-/][A-Za-z0-9]{2,9}[-/][0-9]{2,4})/i)?.[1] || "";

                const placeOfSupply = text.match(/place\s*of\s*supply[:\s]*([A-Za-z0-9 -]+)/i)?.[1]?.trim() || "";


                function extractParties(text) {
                    const lines = text
                        .split("\n")
                        .map(l => l.trim())
                        .filter(Boolean);

                    let result = {
                        billTo: "",
                        shipTo: "",
                        billFrom: "",
                        shipFrom: ""
                    };

                    const isTableHeader = line =>
                        /description|qty|rate|taxable|cgst|sgst|total/i.test(line);

                    const isNumericLine = line =>
                        /^\d+\s/.test(line);

                    for (let i = 0; i < lines.length; i++) {

                        const line = lines[i].toLowerCase();

                        // Detect Bill To / Ship To line
                        if (/bill?\s*to/i.test(line) && /ship\s*to/i.test(line)) {

                            // Look ahead max 3 lines only
                            for (let j = i + 1; j <= i + 3 && j < lines.length; j++) {

                                const nextLine = lines[j];

                                if (isTableHeader(nextLine)) break;
                                if (isNumericLine(nextLine)) break;
                                if (nextLine.startsWith("#")) break;

                                // Likely party line
                                const parts = nextLine.split(/\s{2,}|\t/);

                                if (parts.length >= 2) {
                                    result.billTo = parts[0].trim();
                                    result.shipTo = parts[1].trim();
                                } else {
                                    // If single block, split half
                                    const words = nextLine.split(" ");
                                    const mid = Math.ceil(words.length / 2);
                                    result.billTo = words.slice(0, mid).join(" ");
                                    result.shipTo = words.slice(mid).join(" ");
                                }

                                break;
                            }
                        }
                    }

                    return result;
                }


                // Bill To & Ship To
                // const customerLine = text.match(/demo customer demo customer/i);
                // const billTo = customerLine ? "Demo Customer" : "";
                // const shipTo = customerLine ? "Demo Customer" : "";

                const { billTo, shipTo, billFrom, shipFrom } = extractParties(text);


                /* -----------------------------
                    3. FIX AMOUNTS
                    (100000 → 1000)
                ----------------------------- */

                function fixAmount(numStr) {
                    if (!numStr) return "";

                    const clean = numStr.replace(/,/g, "");

                    if (/^\d{5,}$/.test(clean)) {
                    return String(parseInt(clean) / 100);
                    }

                    return clean;
                }


                /* -----------------------------
                    4. EXTRACT ITEM ROW
                ----------------------------- */

                const lines = text.split("\n");

                let itemRow = lines.find(l => /^1\s/i.test(l));

                let item = {};

                if (itemRow) {

                    // Example:
                    // 1 sample item 10 pcs 100 100000 2600 2500 105000

                    const parts = itemRow.trim().split(/\s+/);

                    item.description = parts[1] + " " + parts[2]; // sample item
                    item.description =
                    item.description.charAt(0).toUpperCase() +
                    item.description.slice(1);

                    item.qty = parts[3];
                    item.unit = parts[4].toUpperCase() === "PCS" ? "Pcs" : parts[4];
                    item.rate = parts[5];

                    const taxableRaw = parts[6];
                    const cgstRaw = parts[7];
                    const sgstRaw = parts[8];

                    // Fix numbers
                    const taxable = fixAmount(taxableRaw);
                    const cgst = fixAmount(cgstRaw);
                    const sgst = fixAmount(sgstRaw);

                    console.log(taxable);

                    // Validate via math
                    const calculatedTaxable =
                    parseFloat(item.qty) * parseFloat(item.rate);

                    item.taxable = String(calculatedTaxable);

                    // If CGST looks too big, assume decimal missing
                    item.cgst =
                    parseFloat(cgst) > 100
                        ? String(parseFloat(cgst) / 100)
                        : cgst;

                    item.sgst =
                    parseFloat(sgst) > 100
                        ? String(parseFloat(sgst) / 100)
                        : sgst;
                }


                /* -----------------------------
                    5. FINAL JSON
                ----------------------------- */

                return {
                    invoiceNo: invoiceNo,
                    invoiceDate,
                    placeOfSupply,
                    billTo,
                    shipTo,
                    billFrom,
                    shipFrom,
                    items: item ? [item] : []
                };
            }



            // fixOCRWords(text, DICTIONARY) {
            // // let t = text.toLowerCase();

            //     for (const wrong in DICTIONARY) {
            //         const regex = new RegExp("\\b" + wrong + "\\b", "gi");
            //         text = text.replace(regex, DICTIONARY[wrong]);
            //     }

            //     return text;
            // },  

            // cleanOCR(text) {
            // return text
            //     .replace(/\s+/g, " ")        // remove line breaks
            //     .replace(/[^\w\s₹.,:@-]/g,"") // remove junk symbols
            //     .trim();
            // },

            // extractInvoice(text) {
            //     const data = {};

            //     data.invoiceNo = text.match(/invoice\s*no[:#]?\s*(\w+)/i)?.[1];
            //     data.invoiceDate = text.match(/date\s*of\s*invoice[: ]+([0-9A-Za-z-]+)/i)?.[1];
            //     data.placeOfSupply = text.match(/place\s*of\s*supply[: ]+([A-Za-z -0-9]+)/i)?.[1];

            //     data.total = text.match(/total\s*amount.*?([0-9,]+\.\d{2})/i)?.[1];
            //     data.taxable = text.match(/taxable\s*amount.*?([0-9,]+\.\d{2})/i)?.[1];
            //     data.cgst = text.match(/cgst.*?([0-9,]+\.\d{2})/i)?.[1];
            //     data.sgst = text.match(/sgst.*?([0-9,]+\.\d{2})/i)?.[1];

            //     return data;
            // },

            // extractItems(text) {
            //     let headers = [];


            //     const lines = text.split(/\d+\s+/); // split where item numbers exist
            //     const items = [];

            //     for (const line of lines) {
            //         const parts = line.trim().split(" ");

            //         if (parts.length < 7) continue;

            //         const numbers = parts.filter(p => /\d/.test(p));
            //         if (numbers.length < 6) continue;

            //         items.push({
            //         description: parts.slice(0, parts.length - numbers.length).join(" "),
            //         qty: numbers[0],
            //         unit: numbers[1],
            //         rate: numbers[2],
            //         taxable: numbers[3],
            //         cgst: numbers[4],
            //         sgst: numbers[5],
            //         total: numbers[6]
            //         });
            //     }

            //     return items;
            // },

            // extractItems(ocrText, HEADER_SYNONYMS) {
            //     const lines = ocrText.split("\n");

            //     const header = this.detectHeaderLine(lines, HEADER_SYNONYMS);
            //     if (!header) return [];

            //     const cols = this.detectColumns(header, HEADER_SYNONYMS);
            //     const headerIndex = lines.indexOf(header);

            //     const items = [];

            //     for (let i = headerIndex + 1; i < lines.length; i++) {
            //         const line = lines[i];

            //         if (/total|grand|sub\s*total/i.test(line)) break;
            //         if (!/\d/.test(line)) continue;

            //         const row = {};
            //         const sortedCols = Object.entries(cols).sort((a,b) => a[1] - b[1]);

            //         for (let j = 0; j < sortedCols.length; j++) {
            //         const [key, start] = sortedCols[j];
            //         const end = sortedCols[j+1]?.[1] || line.length;
            //         row[key] = line.substring(start, end).trim();
            //         }

            //         // validate numeric structure
            //         if (row.qty && row.total || row.amount) {
            //         items.push(row);
            //         }
            //     }

            //     return items;
            // },

            // detectHeaderLine(lines, HEADER_SYNONYMS) {
            //     for (const line of lines) {
            //         let score = 0;
            //         for (const key in HEADER_SYNONYMS) {
            //         if (HEADER_SYNONYMS[key].some(w => line.toLowerCase().includes(w))) {
            //             score++;
            //         }
            //         }
            //         if (score >= 4) return line;   // 4+ columns found → table header
            //     }
            //     return null;
            // },

            // detectColumns(headerLine, HEADER_SYNONYMS) {
            //     const columns = {};

            //     for (const key in HEADER_SYNONYMS) {
            //         for (const word of HEADER_SYNONYMS[key]) {
            //         const idx = headerLine.toLowerCase().indexOf(word);
            //         if (idx !== -1) {
            //             columns[key] = idx;
            //             break;
            //         }
            //         }
            //     }

            //     return columns;
            // }

        },  
        mounted: function(){

            // let self = this;
            // document.getElementById("file").addEventListener("change", async function () {
			// 	const file = this.files[0];

			// 	// const { data: { text } } = await Tesseract.recognize(
			// 	// 	file,
			// 	// 	"eng",
			// 	// 	{ 
            //     //         "tessedit_char_whitelist":"0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz₹.,:-/%",
            //     //         "preserve_interword_spaces": 1,
            //     //         "user_defined_dpi": 300,
            //     //         logger: m => console.log(m)
            //     //     }
			// 	// );

            //     await initOCR();

            //     const data = await runOCR(file);

            //     let text = data.text;
			// 	console.log(text);

            //     // const HEADER_SYNONYMS = {
            //     //     description: ["description", "item", "product", "particulars", "details"],
            //     //     qty: ["qty", "quantity", "nos", "pcs", "units"],
            //     //     unit: ["unit", "uom", "pack"],
            //     //     rate: ["rate", "price", "mrp"],
            //     //     taxable: ["taxable", "tax value", "amount"],
            //     //     cgst: ["cgst", "c.g.s.t"],
            //     //     sgst: ["sgst", "s.g.s.t"],
            //     //     igst: ["igst", "i.g.s.t"],
            //     //     total: ["total", "net", "value"]
            //     // };

            //     // const DICTIONARY = {
            //     //     "dato": "Date",
            //     //     "Inveice": "Invoice",
            //     //     "Deli": "Delhi",
            //     //     "Delli": "Delhi",
            //     //     "stn": "GSTIN",
            //     //     "ostin": "GSTIN",
            //     //     "tem": "Item",
            //     //     "qty": "qty",
            //     //     "oty": "qty",
            //     //     "c6st": "CGST",
            //     //     "s6st": "SGST"
            //     // };
                
            //     // let fixedText = self.fixOCRWords(text, DICTIONARY);

            //     // const clean = self.cleanOCR(fixedText);

            //     // const invoice = self.extractInvoice(clean);
            //     // invoice.items = self.extractItems(fixedText, HEADER_SYNONYMS);

            //     // console.log(JSON.stringify(invoice, null, 2));
			// 	// document.getElementById("output").textContent = text;
                    
            //     const result = self.parseInvoiceOCR(text);
            //     console.log(JSON.stringify(result, null, 2));
            // });
            // this.fn_showWebView();

            // window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
            
            if(this.$route.params && this.$route.params.tagId){
                this.fn_get(this.$route.params.tagId);
            }

            this.$eventHub.$on('delete', () => {
                this.displayData && !this.displayData.isSystem ? this.fn_openDialogConfirmation() : '';
            });

            this.$eventHub.$on('edit', () => {
                this.displayData && !this.displayData.isSystem ? this.fn_edit() : '';
            });

            let isCalled = false;

            this.$eventHub.$once('connected', () => {
                setTimeout(() => {
                    if(this.$route.params && this.$route.params.tagId && !isCalled){
                        isCalled = true;
                        this.fn_get(this.$route.params.tagId);
                    }
                }, 1000);
            });
        },
        beforeRouteUpdate(to, from, next){
            this.$eventHub.$off('connected');
            
            if(to.params && to.params.tagId){
                this.fn_get(to.params.tagId);
            }

            let isCalled = false;

            this.$eventHub.$once('connected', () => {
                setTimeout(() => {
                    if(this.$route.params && this.$route.params.tagId && !isCalled){
                        isCalled = true;
                        this.fn_get(this.$route.params.tagId);
                    }
                }, 1000);
            });

            next(true);
        },
        beforeRouteLeave(to, from, next){
            this.$eventHub.$off('delete');
            this.$eventHub.$off('edit');
            this.$eventHub.$off('connected');
            next(true)
        },
        
    }

</script>